/* eslint-env browser, jquery */

'use strict';

// groupon-deal-timer
require('../../../groupon-deal-timer/frontend/standard');

const CircularProgressBar = require('../../../circular_progress_bar/frontend/views/circular_progress_bar');

const { attributeNames, classNames } = require('./constants');

const UPDATE_COUNTDOWN_MS = 1000;

class JuiceProgramView {
  constructor({ isOverlay, model, selectors }) {
    this.selectors = selectors;
    this.optionSelected = this.optionSelected.bind(this);
    this.viewMoreButtonClicked = this.viewMoreButtonClicked.bind(this);
    this.model = model;
    this.juiceProgramEnded = !this.model.timeLeft();
    this.$el = document.querySelector(`${this.selectors.wrapper}`);

    this.$el.classList.add(classNames.juiceProgramEnabled);

    this.overlayExists = !!isOverlay;

    this.progressBar = new CircularProgressBar({
      selector: `${this.selectors.wrapper} ${this.selectors.bannerMessage}`,
    });

    this.hasViewMoreButtonBeenClicked = false;

    this.$el
      .querySelectorAll(`${this.selectors.input}`)
      .forEach($inputEl =>
        $inputEl.addEventListener('click', this.optionSelected)
      );

    const $viewMoreBtn = document.querySelector(this.selectors.viewMoreButton);
    if (this.overlayExists && $viewMoreBtn) {
      $viewMoreBtn.addEventListener('click', this.viewMoreButtonClicked);
    }
  }

  render() {
    if (this._juiceTimer) {
      clearInterval(this._juiceTimer);
    }
    this._juiceTimer = setInterval(
      () => this.updateJuiceCountdown(),
      UPDATE_COUNTDOWN_MS
    );
    return this;
  }

  optionSelected(e) {
    this.updateJuicePrices(e.currentTarget);
  }

  viewMoreButtonClicked() {
    // If view button is clicked before selecting another option,
    // regular price element in overlay probably is not added yet.
    // This is only needed for the very first click on view button.
    if (!this.hasViewMoreButtonBeenClicked) {
      this.updateJuicePrices(
        this.$el.querySelector(`${this.selectors.input}:checked`)
      );
      this.hasViewMoreButtonBeenClicked = true;
    }
  }

  updateJuicePrices($option) {
    if (this.juiceProgramEnded || !$option) {
      return;
    }
    this.$el.querySelector(
      this.selectors.extraDiscount
    ).textContent = $option.getAttribute(attributeNames.extraDiscount);
  }

  updateJuiceCountdown() {
    const timeLeft = this.model.timeLeft();
    if (timeLeft) {
      this.$el.querySelector(this.selectors.timerInBannerMessage).textContent =
        timeLeft.textTime;
      this.progressBar.updateProgress(timeLeft.progress, timeLeft.clockTime);

      // Use same time format for countdown timer in deal highlights,
      // hence cancel the timer in deal highlights.
      const $dealHighlightsTimer = this.$el.querySelector('.countdown-timer');
      if ($dealHighlightsTimer) {
        $dealHighlightsTimer.textContent = timeLeft.clockTime;
      }

      const countDownTimer =
        window.CountdownTimer &&
        window.CountdownTimer.current &&
        window.CountdownTimer.current.timerView &&
        window.CountdownTimer.current.timerView.interval;
      clearInterval(countDownTimer);
    } else {
      this.juiceProgramEnded = true;
      clearInterval(this._juiceTimer);
      this.cleanJuiceUI();
      this.$el
        .querySelectorAll(`${this.selectors.input}`)
        .forEach($inputEl =>
          $inputEl.removeEventListener('click', this.optionSelected)
        );

      const $viewMoreBtn = document.querySelector(
        this.selectors.viewMoreButton
      );
      if (this.overlayExists && $viewMoreBtn) {
        $viewMoreBtn.removeEventListener('click', this.viewMoreButtonClicked);
      }

      window.DealEventPipe.trigger('juice_price_ended');
    }
  }

  cleanJuiceUI() {
    this.removeJuiceElements();
    this.changeToOldPrices();
    this.$el.classList.add(classNames.juiceProgramExpired);
    this.$el.classList.remove(classNames.juiceProgramEnabled);

    const $bannerMessage = this.$el.querySelector(this.selectors.bannerMessage);
    if ($bannerMessage) {
      const removeBannerMessage = () =>
        $bannerMessage.parentNode.removeChild($bannerMessage);

      Object.assign($bannerMessage.style, {
        height: '0px',
        padding: '0px',
      });
      if ('ontransitionend' in window) {
        $bannerMessage.addEventListener('transitionend', removeBannerMessage, {
          once: true,
        });
      } else {
        setTimeout(() => removeBannerMessage, 2000);
      }
    }
  }

  removeJuiceElements() {
    [
      this.selectors.offerLabel,
      this.selectors.discountBadge,
      this.selectors.overlayClusterDiscount,
      this.selectors.doubleStrikePrice,
    ].forEach(selector => {
      const $juiceEls = this.$el.querySelectorAll(selector);
      $juiceEls.forEach($juiceEl => $juiceEl.parentNode.removeChild($juiceEl));
    });
  }

  changeToOldPrices() {
    this.$el.querySelectorAll('.breakout-option-price').forEach($priceEl => {
      $priceEl.classList.add('c-txt-price');
      $priceEl.classList.remove('urgency-pricing', 'c-txt-err');
    });

    // Change data attributes for each option
    const attrsToRemove = [
      attributeNames.regularPrice,
      attributeNames.extraDiscount,
      attributeNames.discountPercentage,
      attributeNames.offerLabel,
    ];
    // fix this
    const $inputs = this.$el.querySelectorAll(`${this.selectors.input}`);
    $inputs.forEach($input => {
      const regularPrice = $input.getAttribute(attributeNames.regularPrice);
      attrsToRemove.forEach(attr => $input.removeAttribute(attr));

      $input.setAttribute(attributeNames.price, regularPrice);
      const $priceLabel = $input.parentNode.querySelector(
        '.breakout-option-price'
      );
      if ($priceLabel) {
        $priceLabel.textContent = regularPrice;
      }
    });

    // Update price in overlay cluster
    if (this.overlayExists) {
      const price = this.$el
        .querySelector(`${this.selectors.input}:checked`)
        .getAttribute(attributeNames.price);

      const $overlayPrice = this.$el.querySelector(
        this.selectors.overlayClusterPrice
      );
      if ($overlayPrice) {
        $overlayPrice.textContent = price;
        $overlayPrice.classList.add('c-txt-price');
        $overlayPrice.classList.remove('tooltip-trigger', 'urgency-pricing');
      }
    }
  }
}

module.exports = JuiceProgramView;
